<template>
	<TnParagraph size="xs"
		>{{ stock.text }}
		<TnIcon
			class="icon"
			:name="stock.icon"
	/></TnParagraph>
</template>

<script>
import { generateMessageToDisplay } from "~/helpers/ecommerce/clickAndCollect/clickAndCollectMessageUtil";

export default {
	name: "EcommerceClickAndCollectStockStatus",
	props: {
		stockQuantity: {
			type: Number,
			required: true,
		},
		store: {
			type: Object,
			required: true,
		},
	},
	computed: {
		stock() {
			const stock = parseInt(this.stockQuantity);

			if (stock > 0) {
				return {
					text: generateMessageToDisplay(this.store),
					icon: "success-circle-filled",
				};
			} else {
				return { text: "Ikke på lager", icon: "warning-circle-filled" };
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.icon {
	position: relative;
	top: 7px;
}
</style>
